import React, { Component } from 'react';
import './topHeader.css'
import {
    Row,
    Col,Alert
} from "antd";
import SearchComponent from './searchComponent/searchComponent'
import VedicLogo from "./vishnu_logo.png";
import { RenderMenu } from '../header/components/renderMenu';

class TopHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const {title} = this.props
        return (
            <>
           
            <Row className="topHeader">
           
                <Row gutter={4} type="flex" justify="center" align="middle" style={{marginTop:50,marginBottom:25, display: 'flex', alignItems: 'center'}}>

                        <Col xs={0} sm={0} md={2} lg={2} xl={2} ><img style={{ width: '67%' }} src={VedicLogo}></img> </Col>
                        <Col ><h1 id="topHeaderH1">{title}</h1></Col>
                 
                </Row>
                <Row type="flex" justify="center" align="middle">
                    <SearchComponent />
                </Row>
            </Row>
            </>
        );
    }
}

export default TopHeader;